<template>
  <main data-preview-id="">
    <div class="content-container-outer">
      <div class="content-container">
        <div class="kb-breadcrumbs">
          <div class="kb-breadcrumbs__mobile-back">
            <svg
              class="kb-breadcrumbs__arrow kb-breadcrumbs__arrow--left"
              width="7"
              height="12"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M.055 5.7194c.018-.045.0518-.0835.0795-.125.0166-.0255.0322-.052.0489-.0775.007-.011.0116-.024.0216-.034L5.2426.2328c.2877-.3.7662-.3115 1.0685-.026a.7468.7468 0 0 1 .0262 1.0605L1.7954 6l4.5419 4.733a.7462.7462 0 0 1-.0262 1.0601.7563.7563 0 0 1-.5214.207.7568.7568 0 0 1-.547-.2325L.205 6.5174c-.01-.0105-.0146-.023-.0216-.0345-.0167-.025-.0323-.0515-.0489-.077-.0277-.0415-.0615-.08-.0796-.125-.0186-.0455-.0222-.0935-.0312-.141C.0147 6.0934 0 6.0474 0 5.9999c0-.047.0146-.093.0237-.1395.009-.0475.0126-.096.0312-.141"
                fill="#7C98B6"
                fill-rule="evenodd"
              />
            </svg>
            <a href="/qa">ホームに戻る</a>
          </div>
          <ol
            itemscope=""
            itemtype="http://schema.org/BreadcrumbList"
          >
            <li
              itemprop="itemListElement"
              itemscope=""
              itemtype="http://schema.org/ListItem"
            >
              <a
                itemprop="item"
                href="/qa"
              >
                <span itemprop="name">サポートトップ</span>
              </a>
              <meta
                itemprop="position"
                content="1"
              >
            </li>
          </ol>
        </div>
        <div class="main-body">
          <Sidebar />
          <div class="kb-content">
            <div class="kb__404-section">
              <h1>お探しのページが見つからないようです。</h1>
              <p>
                申し訳ありません。もう一度初めから検索をお試しになる場合は、
                <a href="/qa">こちら。</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import axios from '@axios'
import Sidebar from '../components/Sidebar.vue'

export default {
  name: 'NotFoundPage',
  components: {
    Sidebar
  },
  data() {
    return {
      title: '',
      faq_categories: [],
    }
  },
  computed: {
    categoryParents() {
      return this.faq_categories.map((category) => {
        return {
          id: category.id,
          name: category.name,
          description: category.description
        }
      })
    }
  },
  mounted() {
    this.title = 'FAQ'
    this.fetchFaqCategories()
  },
  methods: {
    async fetchFaqCategories() {
      try {
        const { data } = await axios.get('/api/v2/faq_categories')
        this.faq_categories = data.faq_categories
      } catch (error) {
        //
      }
    },
  },


}
</script>

<style lang="scss" scoped></style>
